<app-update-banner />
<div class="top">
  <app-top></app-top>
</div>
<div class="middle">
  <div class="left" [class.hidden]="!isSidebarOpen">
    <app-sidebar (toggleSidebar)="onSidebarToggle()"></app-sidebar>
  </div>
  <div class="right">
    <button mat-icon-button class="toggle-btn" (click)="onSidebarToggle()">
      <mat-icon>{{ isSidebarOpen ? 'menu_open' : 'menu' }}</mat-icon>
    </button>
    <router-outlet />
  </div>
</div>
